/* @ts-self-types="./chip_ahoyto.d.ts" */

export class Chip8Classic {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        Chip8ClassicFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_chip8classic_free(ptr, 0);
    }
    /**
     * @returns {boolean}
     */
    beep_wa() {
        const ret = wasm.chip8classic_beep_wa(this.__wbg_ptr);
        return ret !== 0;
    }
    clock_dt_wa() {
        wasm.chip8classic_clock_dt_wa(this.__wbg_ptr);
    }
    clock_st_wa() {
        wasm.chip8classic_clock_st_wa(this.__wbg_ptr);
    }
    clock_wa() {
        wasm.chip8classic_clock_wa(this.__wbg_ptr);
    }
    /**
     * @returns {Uint8Array}
     */
    get_state_wa() {
        const ret = wasm.chip8classic_get_state_wa(this.__wbg_ptr);
        var v1 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        return v1;
    }
    /**
     * @param {number} key
     */
    key_lift_wa(key) {
        wasm.chip8classic_key_lift_wa(this.__wbg_ptr, key);
    }
    /**
     * @param {number} key
     */
    key_press_wa(key) {
        wasm.chip8classic_key_press_wa(this.__wbg_ptr, key);
    }
    /**
     * @param {Uint8Array | number[]} rom
     */
    load_rom_wa(rom) {
        const ptr0 = passArray8ToWasm0(rom, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.chip8classic_load_rom_wa(this.__wbg_ptr, ptr0, len0);
    }
    constructor() {
        const ret = wasm.chip8classic_new();
        this.__wbg_ptr = ret;
        Chip8ClassicFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    pause_wa() {
        wasm.chip8classic_pause_wa(this.__wbg_ptr);
    }
    /**
     * @returns {boolean}
     */
    paused_wa() {
        const ret = wasm.chip8classic_paused_wa(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @returns {Registers}
     */
    registers_wa() {
        const ret = wasm.chip8classic_registers_wa(this.__wbg_ptr);
        return Registers.__wrap(ret);
    }
    reset_hard_wa() {
        wasm.chip8classic_reset_hard_wa(this.__wbg_ptr);
    }
    reset_wa() {
        wasm.chip8classic_reset_wa(this.__wbg_ptr);
    }
    /**
     * @param {Uint8Array | number[]} state
     */
    set_state_wa(state) {
        const ptr0 = passArray8ToWasm0(state, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.chip8classic_set_state_wa(this.__wbg_ptr, ptr0, len0);
    }
    vblank_wa() {
        wasm.chip8classic_vblank_wa(this.__wbg_ptr);
    }
    /**
     * @returns {Uint8Array}
     */
    vram_wa() {
        const ret = wasm.chip8classic_vram_wa(this.__wbg_ptr);
        var v1 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        return v1;
    }
}
if (Symbol.dispose) Chip8Classic.prototype[Symbol.dispose] = Chip8Classic.prototype.free;

export class Chip8Neo {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        Chip8NeoFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_chip8neo_free(ptr, 0);
    }
    /**
     * @returns {boolean}
     */
    beep_wa() {
        const ret = wasm.chip8neo_beep_wa(this.__wbg_ptr);
        return ret !== 0;
    }
    clock_dt_wa() {
        wasm.chip8neo_clock_dt_wa(this.__wbg_ptr);
    }
    clock_st_wa() {
        wasm.chip8neo_clock_st_wa(this.__wbg_ptr);
    }
    clock_wa() {
        wasm.chip8neo_clock_wa(this.__wbg_ptr);
    }
    /**
     * @returns {Uint8Array}
     */
    get_state_wa() {
        const ret = wasm.chip8neo_get_state_wa(this.__wbg_ptr);
        var v1 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        return v1;
    }
    /**
     * @param {number} key
     */
    key_lift_wa(key) {
        wasm.chip8neo_key_lift_wa(this.__wbg_ptr, key);
    }
    /**
     * @param {number} key
     */
    key_press_wa(key) {
        wasm.chip8neo_key_press_wa(this.__wbg_ptr, key);
    }
    /**
     * @param {Uint8Array | number[]} rom
     */
    load_rom_wa(rom) {
        const ptr0 = passArray8ToWasm0(rom, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.chip8neo_load_rom_wa(this.__wbg_ptr, ptr0, len0);
    }
    constructor() {
        const ret = wasm.chip8neo_new();
        this.__wbg_ptr = ret;
        Chip8NeoFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    pause_wa() {
        wasm.chip8neo_pause_wa(this.__wbg_ptr);
    }
    /**
     * @returns {boolean}
     */
    paused_wa() {
        const ret = wasm.chip8neo_paused_wa(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @returns {Registers}
     */
    registers_wa() {
        const ret = wasm.chip8neo_registers_wa(this.__wbg_ptr);
        return Registers.__wrap(ret);
    }
    reset_hard_wa() {
        wasm.chip8neo_reset_hard_wa(this.__wbg_ptr);
    }
    reset_wa() {
        wasm.chip8neo_reset_wa(this.__wbg_ptr);
    }
    /**
     * @param {Uint8Array | number[]} state
     */
    set_state_wa(state) {
        const ptr0 = passArray8ToWasm0(state, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.chip8neo_set_state_wa(this.__wbg_ptr, ptr0, len0);
    }
    vblank_wa() {
        wasm.chip8neo_vblank_wa(this.__wbg_ptr);
    }
    /**
     * @returns {Uint8Array}
     */
    vram_wa() {
        const ret = wasm.chip8neo_vram_wa(this.__wbg_ptr);
        var v1 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        return v1;
    }
}
if (Symbol.dispose) Chip8Neo.prototype[Symbol.dispose] = Chip8Neo.prototype.free;

export class Info {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        InfoFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_info_free(ptr, 0);
    }
    /**
     * Obtains the name of the emulator.
     * @returns {string}
     */
    static name() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.info_name();
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * Obtains the name of the emulator in lowercase.
     * Useful for file paths and other cases where.
     * @returns {string}
     */
    static name_lower() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.info_name_lower();
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * Obtains the system this emulator is emulating.
     * @returns {string}
     */
    static system() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.info_system();
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * Obtains the version of the emulator.
     * @returns {string}
     */
    static version() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.info_version();
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
}
if (Symbol.dispose) Info.prototype[Symbol.dispose] = Info.prototype.free;

export class Registers {
    static __wrap(ptr) {
        const obj = Object.create(Registers.prototype);
        obj.__wbg_ptr = ptr;
        RegistersFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        RegistersFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_registers_free(ptr, 0);
    }
    /**
     * @returns {number}
     */
    get dt() {
        const ret = wasm.__wbg_get_registers_dt(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {number}
     */
    get i() {
        const ret = wasm.__wbg_get_registers_i(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {number}
     */
    get pc() {
        const ret = wasm.__wbg_get_registers_pc(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {number}
     */
    get sp() {
        const ret = wasm.__wbg_get_registers_sp(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {number}
     */
    get st() {
        const ret = wasm.__wbg_get_registers_st(this.__wbg_ptr);
        return ret;
    }
    /**
     * @param {number} arg0
     */
    set dt(arg0) {
        wasm.__wbg_set_registers_dt(this.__wbg_ptr, arg0);
    }
    /**
     * @param {number} arg0
     */
    set i(arg0) {
        wasm.__wbg_set_registers_i(this.__wbg_ptr, arg0);
    }
    /**
     * @param {number} arg0
     */
    set pc(arg0) {
        wasm.__wbg_set_registers_pc(this.__wbg_ptr, arg0);
    }
    /**
     * @param {number} arg0
     */
    set sp(arg0) {
        wasm.__wbg_set_registers_sp(this.__wbg_ptr, arg0);
    }
    /**
     * @param {number} arg0
     */
    set st(arg0) {
        wasm.__wbg_set_registers_st(this.__wbg_ptr, arg0);
    }
}
if (Symbol.dispose) Registers.prototype[Symbol.dispose] = Registers.prototype.free;
function __wbg_get_imports() {
    const import0 = {
        __proto__: null,
        __wbg___wbindgen_is_function_741ff2bb612836f5: function(arg0) {
            const ret = typeof(arg0) === 'function';
            return ret;
        },
        __wbg___wbindgen_is_object_8b968c3ab8e96595: function(arg0) {
            const val = arg0;
            const ret = typeof(val) === 'object' && val !== null;
            return ret;
        },
        __wbg___wbindgen_is_string_fc456fee5d3317de: function(arg0) {
            const ret = typeof(arg0) === 'string';
            return ret;
        },
        __wbg___wbindgen_is_undefined_be5b34249ff1fc15: function(arg0) {
            const ret = arg0 === undefined;
            return ret;
        },
        __wbg___wbindgen_throw_4c88d8bf264fd984: function(arg0, arg1) {
            throw new Error(getStringFromWasm0(arg0, arg1));
        },
        __wbg_call_a410eb4b59ed5965: function() { return handleError(function (arg0, arg1, arg2) {
            const ret = arg0.call(arg1, arg2);
            return ret;
        }, arguments); },
        __wbg_crypto_23f565a907d30078: function(arg0) {
            const ret = arg0.crypto;
            return ret;
        },
        __wbg_getRandomValues_d2908e0b99612b91: function() { return handleError(function (arg0, arg1) {
            arg0.getRandomValues(arg1);
        }, arguments); },
        __wbg_length_186163212ffe79c3: function(arg0) {
            const ret = arg0.length;
            return ret;
        },
        __wbg_msCrypto_d5f06fad6bf1409b: function(arg0) {
            const ret = arg0.msCrypto;
            return ret;
        },
        __wbg_new_with_length_01b143a7e5dd5a3e: function(arg0) {
            const ret = new Uint8Array(arg0 >>> 0);
            return ret;
        },
        __wbg_node_86166ff8ce1f2002: function(arg0) {
            const ret = arg0.node;
            return ret;
        },
        __wbg_process_91f425a63f58e399: function(arg0) {
            const ret = arg0.process;
            return ret;
        },
        __wbg_prototypesetcall_13162965d1fe7aa3: function(arg0, arg1, arg2) {
            Uint8Array.prototype.set.call(getArrayU8FromWasm0(arg0, arg1), arg2);
        },
        __wbg_randomFillSync_34b023059e3363de: function() { return handleError(function (arg0, arg1) {
            arg0.randomFillSync(arg1);
        }, arguments); },
        __wbg_require_9a7d8cc2e1d275c0: function() { return handleError(function () {
            const ret = module.require;
            return ret;
        }, arguments); },
        __wbg_static_accessor_GLOBAL_THIS_003ee833af9699fc: function() {
            const ret = typeof globalThis === 'undefined' ? undefined : globalThis;
            return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
        },
        __wbg_static_accessor_GLOBAL_e4293fb22cbe77da: function() {
            const ret = typeof global === 'undefined' ? undefined : global;
            return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
        },
        __wbg_static_accessor_SELF_53bb20457401453d: function() {
            const ret = typeof self === 'undefined' ? undefined : self;
            return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
        },
        __wbg_static_accessor_WINDOW_b5e0810bfecb7feb: function() {
            const ret = typeof window === 'undefined' ? undefined : window;
            return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
        },
        __wbg_subarray_58f388a9247ac0bb: function(arg0, arg1, arg2) {
            const ret = arg0.subarray(arg1 >>> 0, arg2 >>> 0);
            return ret;
        },
        __wbg_versions_6e128a981b0df859: function(arg0) {
            const ret = arg0.versions;
            return ret;
        },
        __wbindgen_generic_0000000000000001: function(arg0, arg1) {
            // Cast intrinsic for `Ref(Slice(U8)) -> NamedExternref("Uint8Array")`.
            const ret = getArrayU8FromWasm0(arg0, arg1);
            return ret;
        },
        __wbindgen_generic_0000000000000002: function(arg0, arg1) {
            // Cast intrinsic for `Ref(String) -> Externref`.
            const ret = getStringFromWasm0(arg0, arg1);
            return ret;
        },
        __wbindgen_init_externref_table: function() {
            const table = wasm.__wbindgen_externrefs;
            table.set(0, undefined);
            table.set(1024, undefined);
            table.set(1025, null);
            table.set(1026, true);
            table.set(1027, false);
        },
    };
    return {
        __proto__: null,
        "./chip_ahoyto_bg.js": import0,
    };
}

const Chip8ClassicFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_chip8classic_free(ptr, 1));
const Chip8NeoFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_chip8neo_free(ptr, 1));
const InfoFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_info_free(ptr, 1));
const RegistersFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_registers_free(ptr, 1));

function addToExternrefTable0(obj) {
    const idx = wasm.__externref_table_alloc();
    wasm.__wbindgen_externrefs.set(idx, obj);
    return idx;
}

function getArrayU8FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return getUint8ArrayMemory0().subarray(ptr / 1, ptr / 1 + len);
}

function getStringFromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return decodeText(getUint8ArrayMemory0().subarray(ptr, ptr + len));
}

let cachedUint8ArrayMemory0 = null;
function getUint8ArrayMemory0() {
    if (cachedUint8ArrayMemory0 === null || cachedUint8ArrayMemory0.byteLength === 0) {
        cachedUint8ArrayMemory0 = new Uint8Array(wasm.memory.buffer);
    }
    return cachedUint8ArrayMemory0;
}

function handleError(f, args) {
    try {
        return f.apply(this, args);
    } catch (e) {
        const idx = addToExternrefTable0(e);
        wasm.__wbindgen_exn_store(idx);
    }
}

function isLikeNone(x) {
    return x === undefined || x === null;
}

function passArray8ToWasm0(arg, malloc) {
    const ptr = malloc(arg.length * 1, 1) >>> 0;
    getUint8ArrayMemory0().set(arg, ptr / 1);
    WASM_VECTOR_LEN = arg.length;
    return ptr;
}

let cachedTextDecoder = new TextDecoder('utf-8', { ignoreBOM: true });
cachedTextDecoder.decode();
const MAX_SAFARI_DECODE_BYTES = 2146435072;
let numBytesDecoded = 0;
function decodeText(bytes) {
    numBytesDecoded += bytes.length;
    if (numBytesDecoded >= MAX_SAFARI_DECODE_BYTES) {
        cachedTextDecoder = new TextDecoder('utf-8', { ignoreBOM: true });
        cachedTextDecoder.decode();
        numBytesDecoded = bytes.length;
    }
    return cachedTextDecoder.decode(bytes);
}

let WASM_VECTOR_LEN = 0;

let wasmModule, wasmInstance, wasm;
function __wbg_finalize_init(instance, module) {
    wasmInstance = instance;
    wasm = instance.exports;
    wasmModule = module;
    cachedUint8ArrayMemory0 = null;
    wasm.__wbindgen_start();
    return wasm;
}

async function __wbg_load(module, imports) {
    if (typeof Response === 'function' && module instanceof Response) {
        if (!module.ok) {
            throw new Error(`failed to fetch Wasm: ${module.status} ${module.statusText} fetching '${module.url}'`);
        }

        if (typeof WebAssembly.instantiateStreaming === 'function') {
            try {
                return await WebAssembly.instantiateStreaming(module, imports);
            } catch (e) {
                const validResponse = expectedResponseType(module.type);

                if (validResponse && module.headers.get('Content-Type') !== 'application/wasm') {
                    console.warn("`WebAssembly.instantiateStreaming` failed because your server does not serve Wasm with `application/wasm` MIME type. Falling back to `WebAssembly.instantiate` which is slower. Original error:\n", e);

                } else { throw e; }
            }
        }

        const bytes = await module.arrayBuffer();
        return await WebAssembly.instantiate(bytes, imports);
    } else {
        const instance = await WebAssembly.instantiate(module, imports);

        if (instance instanceof WebAssembly.Instance) {
            return { instance, module };
        } else {
            return instance;
        }
    }

    function expectedResponseType(type) {
        switch (type) {
            case 'basic': case 'cors': case 'default': return true;
        }
        return false;
    }
}

function initSync(module) {
    if (wasm !== undefined) return wasm;


    if (module !== undefined) {
        if (Object.getPrototypeOf(module) === Object.prototype) {
            ({module} = module)
        } else {
            console.warn('using deprecated parameters for `initSync()`; pass a single object instead')
        }
    }

    const imports = __wbg_get_imports();
    if (!(module instanceof WebAssembly.Module)) {
        module = new WebAssembly.Module(module);
    }
    const instance = new WebAssembly.Instance(module, imports);
    return __wbg_finalize_init(instance, module);
}

let __wbg_init_promise;
async function __wbg_init(module_or_path) {
    if (wasm !== undefined) return wasm;
    if (__wbg_init_promise === undefined) {
        __wbg_init_promise = __wbg_init_once(module_or_path);
        __wbg_init_promise.catch(() => { __wbg_init_promise = undefined; });
    }
    return __wbg_init_promise;
}

async function __wbg_init_once(module_or_path) {

    if (module_or_path !== undefined) {
        if (Object.getPrototypeOf(module_or_path) === Object.prototype) {
            ({module_or_path} = module_or_path)
        } else {
            console.warn('using deprecated parameters for the initialization function; pass a single object instead')
        }
    }

    if (module_or_path === undefined) {
        module_or_path = new URL('chip_ahoyto_bg.wasm', import.meta.url);
    }
    const imports = __wbg_get_imports();

    if (typeof module_or_path === 'string' || (typeof Request === 'function' && module_or_path instanceof Request) || (typeof URL === 'function' && module_or_path instanceof URL)) {
        module_or_path = fetch(module_or_path);
    }

    const { instance, module } = await __wbg_load(await module_or_path, imports);

    return __wbg_finalize_init(instance, module);
}

export { initSync, __wbg_init as default };
